<template>
  <div id="app" :class="{'enterprise': isEnterprice}"> <!-- class="enterprise" -->
    <loading :mask=true :size="'big'" :isWhite=true v-if="showFullLoading || !ready" :style="{position: 'fixed'}"/>
    <div class="progress-circle" v-if="fwUpdating">
      <div class="progress-logo">
        <vue-circle ref="update" class="login-progress-circle"
          :progress="progress"
          :size="190"
          line-cap="round"
          :fill="progressfill"
          empty-fill="rgba(89,89,89, 1)"
          :start-angle="300"
          insert-mode="append"
          :thickness="4"
          :show-percent="true"
          :percentFontSize="percentFontSize"
          >
        </vue-circle>
      </div>
      <div class="progress-text">{{progressText}}</div>
    </div>
    <login v-if="!isLogin"/>
    <div style="height:inherit;" v-else>
      <station-header/>
      <station-page/>
    </div>
    <popup-confirm name="browser-warning-modal" type="o" :dialog-header="$t('warning')" :dialog-message="$t('login.IEnonsupport')" icon="w" :callback="checkLogin" :pwdWarn="true" :selHeight="249"/>
    <popup-confirm name="switch-reboot-modal" type="y" :dialog-header="$t('restart')" :dialog-message="$t('header.restartMsg')" icon="w" :callback="goReboot" />
    <popup-confirm name="update-warning-modal" type="o" :dialog-header="$t('warning')" :dialog-message="$t('updatefw.downloadFail')" icon="w" :onlyOk="true" />
    <popup-confirm name="timeout-warning-modal" type="o" :dialog-header="dialogHead" :dialog-message="dialogMsg" icon="w" :pwdWarn="true" :callback="goLogout" />
    <popup-confirm name="digital-signature-modal" type="u" :dialog-header="digiTitle" :dialog-message="digiMsg" :dialog-message2="digiMsg2" icon="w" :callback="goUpdate" :onNo="goCancel"/>
    <popup-confirm name="fail-update-modal" type="w" :dialog-header="digiTitle" :dialog-message="digiMsg" icon="w" :onlyOk="true" />
    <errorsWin/>
    <pwd-update/>
  </div>
</template>
<script>
import Vue from 'vue'
import config from './config'
import { mapActions, mapState, mapMutations } from 'vuex'
import Login from './components/Login'
import StationHeader from './components/StationHeader'
import StationPage from './components/StationPage'
import VueCircle from 'vue2-circle-progress'
import pwdUpdate from './components/ForceUpdatePwd'
import errorsWin from './components/errors'
import Encrypt from './util/encrypt'

export default {
  name: 'App',
  components: {
    StationHeader,
    StationPage,
    Login,
    VueCircle,
    pwdUpdate,
    errorsWin
  },
  data () {
    return {
      checkInterval: null,
      systemInterval: null,
      updateInterval: null,
      timeoutInterval: null,
      progressfill: {gradient: ['#28fada']},
      percentFontSize: '30',
      appProgress: 0,
      menuList: {},
      ready: false,
      countDownloadError: 0,
      progressText: this.$t('uploading'),
      startTime: null,
      errorMsg: '',
      localStorageHostname: 'qsw_hostname',
      localStorageModel: 'qsw_moel',
      dialogHead: this.$t('warningWin.timeoutTitle'),
      dialogMsg: this.$t('warningWin.timeoutContent'),
      fwResult: null,
      digiTitle: null,
      digiMsg: null,
      digiMsg2: null
    }
  },
  created: async function () {
    let me = this
    this.menuList = config.menu
    window.addEventListener('beforeunload', function (e) {
      me.$log.info('beforeunload', me)
      me.$log.debug(me.fwUpdating)
      // if (me.fwUpdating) {
      //   e.preventDefault()
      //   e.returnValue = false
      //   return false
      // }
    })
    window.addEventListener('keydown', function (e) {
      if (me.isLogin) {
        me.$store.commit('updateTimeout')
      }
    })
    window.addEventListener('mousemove', function (e) {
      if (me.isLogin) {
        me.$store.commit('updateTimeout')
      }
    })
    window.addEventListener('mousedown', function (e) {
      if (me.isLogin) {
        me.$store.commit('updateTimeout')
      }
    })
    const hostname = this.$localStorage.get(this.localStorageHostname)
    if (hostname) {
      document.title = hostname
    } else {
      document.title = this.$t('qssprojectName')
    }
    await this.localeInit()
    await this.getProductByNoAuth().then((res) => {
      this.$localStorage.set(this.localStorageHostname, res.result.Hostname)
      this.$localStorage.set(this.localStorageModel, res.result.Model)
    })
    this.ready = true
    let browserType = window.navigator.userAgent
    if (browserType.indexOf('MSIE') > -1 || browserType.indexOf('Trident/') > -1) {
      // show IE browser popup
      this.openModal('browser-warning-modal')
      this.$modal.show('browser-warning-modal')
    } else {
      this.checkLogin()
    }
  },
  beforeDestroy () {
    if (this.systemInterval) {
      clearInterval(this.systemInterval)
      this.systemInterval = null
    }
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
      this.updateInterval = null
    }
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  },
  watch: {
    fwUpdating: {
      handler (value) {
        this.$log.debug('App fwUpdating', value)
        if (value) {
          this.appProgress = this.progress
          this.onUpdate()
        } else {
          if (this.showFullLoading) {
            clearInterval(this.updateInterval)
            this.$store.commit('setProgress', 0)
            this.$store.commit('setfwProgressStatus', 'none')
            this.startTime = new Date()
            this.checkRebootingStatus()
            this.$log.info('check rebooting status >>>')
            this.$refs.update.updateProgress(this.appProgress)
          } else {
            clearInterval(this.updateInterval)
          }
        }
      },
      immediate: true
    },
    progress: function (value) {
      let me = this
      this.$log.debug('App progress', value)
      this.appProgress = value
      this.$refs.update.updateProgress(this.appProgress)
      if (this.progress === 100) {
        this.digiMsg2 = null
        setTimeout(function () {
          clearInterval(me.updateInterval)
          if (me.fwResult) {
            let errMessage = me.fwResult.error_message
            switch (errMessage) {
              case 'qcodesign fail':
                me.goCancel()
                me.digiTitle = me.$t('updatefw.digiSignTitle')
                me.digiMsg = me.$t('updatefw.digiSignNotValid')
                me.openModal('fail-update-modal')
                me.$modal.show('fail-update-modal')
                break
              case 'qcert_expired fail':
                let msg = me.$t('updatefw.digiSignExp').split('?')
                me.digiTitle = me.$t('updatefw.digiSignTitle')
                me.digiMsg = msg[0] + '?'
                me.digiMsg2 = msg[1]
                me.openModal('digital-signature-modal')
                me.$modal.show('digital-signature-modal')
                break
              case 'command exec faild : fwver.json not exist in /tmp/firmware.img':
                me.goCancel()
                me.digiTitle = me.$t('warning')
                me.digiMsg = me.$t('updatefw.fwFailContent', {error_code: -3})
                me.openModal('fail-update-modal')
                me.$modal.show('fail-update-modal')
                break
              case 'Command failed: Method not found\n':
                me.goUpdate()
                break
              case 'update version less than minimum version':
                me.goCancel()
                me.digiTitle = me.$t('errorMessage.restoreSystemError')
                me.digiMsg = me.$t('errorMessage.minVersionErr')
                me.openModal('fail-update-modal')
                me.$modal.show('fail-update-modal')
                break
              case 'OK':
                me.goUpdate()
                break
              default:
                me.digiTitle = me.$t('warning')
                me.digiMsg = errMessage
                me.openModal('fail-update-modal')
                me.$modal.show('fail-update-modal')
            }
          } else {
            me.goUpdate()
          }
        }, 10000)
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.systemInterval)
          this.systemInterval = null
          clearInterval(this.updateInterval)
          this.updateInterval = null
          clearInterval(this.checkInterval)
          this.timeoutInterval = null
          clearInterval(this.timeoutInterval)
          this.$store.commit('updateTimeout')
        }
      },
      immediate: true,
      deep: true
    },
    showErrorWin: function (value) {
      if (value.show) {
        // this.errorMsg = value.data.error_message
        this.openModal('error-win-modal')
        this.$modal.show('error-win-modal')
      } else {
        this.closeModal('error-win-modal')
        this.$modal.hide('error-win-modal')
      }
    },
    isLogin: function (value) {
      if (value) {
        this.$log.debug('go check')
        this.checkTimeout()
      } else {
        this.timeoutInterval = null
        window.clearInterval(this.timeoutInterval)
        clearInterval(this.timeoutInterval)
      }
    },
    isShowTimoutWin: function (data) {
      if (data.status) {
        if (data.type === 'timeout') {
          this.dialogHead = this.$t('warningWin.timeoutTitle')
          this.dialogMsg = this.$t('warningWin.timeoutContent')
        } else if (data.type === 'login') {
          this.dialogHead = this.$t('warningWin.timeoutTitle')
          this.dialogMsg = this.$t('warningWin.repeatLogin')
        } else if (data.type === 'busy') {
          this.dialogHead = this.$t('warningWin.busyTitle')
          this.dialogMsg = this.$t('warningWin.busyContent')
        }
        this.openModal('timeout-warning-modal')
        this.$modal.show('timeout-warning-modal')
      } else {
        this.closeModal('timeout-warning-modal')
        this.$modal.hide('timeout-warning-modal')
      }
    }
  },
  methods: {
    onUpdate: function () {
      this.progressText = this.$t('uploading')
      setTimeout(() => {
        this.updateInterval = setInterval(() => {
          this.$log.info('update firmware')
          this.getStatus()
        }, 2000)
        this.getStatus()
      }, 1000)
    },
    checkRebootingStatus: function (newTime) {
      let me = this
      let count = 0
      this.$log.debug('checkRebootingStatus')
      if (newTime) {
        this.startTime = new Date()
      }
      this.checkSwitchReboot()
      this.updateInterval = setInterval(() => {
        this.$log.info('update firmware')
        this.checkSwitchReboot()
          .then((result) => {
            if (result.data) {
              count++
              if (count > 5) {
                clearInterval(this.updateInterval)
                window.location.reload(true)
                this.$store.commit('setLoadingType', '')
                this.$store.commit('updateFullLoadingStatus', false)
              }
            }
          }).catch((error) => {
            if (error.message === 'Network Error' && window.location.protocol === 'https:') {
              count++
              if (count > 30) {
                clearInterval(this.updateInterval)
                window.location.reload(true)
                this.$store.commit('setLoadingType', '')
                this.$store.commit('updateFullLoadingStatus', false)
              }
            } else {
              count = 0
              me.$log.error(error)
              let currentTime = new Date()
              if ((currentTime - me.startTime) > 360000) {
                clearInterval(me.updateInterval)
              }
            }
          })
      }, 4000)
    },
    getStatus: function () {
      this.getFWupdateStatus()
        .then((res) => {
          this.$log.debug(res)
          let result = res
          if (result.Status && result.Status.error_code === 404) {
            this.countDownloadError++
            if (this.countDownloadError > 2) {
              this.openModal('update-warning-modal')
              this.$modal.show('update-warning-modal')
              clearInterval(this.updateInterval)
              this.$store.commit('setLoadingType', '')
              this.$store.commit('updateFullLoadingStatus', false)
              this.$store.commit('setUpdateStatus', false)
              this.countDownloadError = 0
            }
          } else {
            if (result.firmwareSize && result.firmwareSize !== 0) {
              if (result.Status) {
                this.fwResult = result.Status
                if (this.fwResult.error_message === 'OK') this.appProgress = 100
              } else {
                this.appProgress = Math.floor((result.downloadSize / result.firmwareSize) * 100)
              }
            } else {
              this.appProgress = 0
            }
          }
          this.$store.commit('setProgress', this.appProgress)
        }).catch((err) => {
          this.$log.error(err)
          clearInterval(this.updateInterval)
          this.updateInterval = null
          this.$store.commit('setLoadingType', '')
          this.$store.commit('updateFullLoadingStatus', false)
          this.$store.commit('setUpdateStatus', false)
          this.countDownloadError = 0
        })
    },
    localeInit: async function () {
      let trans = 'ENG'
      let nasLang = null // this.$cookie.get('QSW_LANG')
      await this.getWebConfig().then(res => {
        nasLang = res.result['Language']
      })
      if (nasLang !== 'AUTO') {
        trans = nasLang
      } else {
        let lang = window.navigator.userLanguage || window.navigator.language
        this.$store.commit('updateAutoDetect', true)
        if (lang) {
          lang = lang.replace('-', '_')
          if (lang.split('_')[0] === 'zh') {
            lang = lang.split('_')[1]
          } else {
            lang = lang.split('_')[0]
          }
          config.languages.forEach(function (e, i, a) {
            if (lang === e[0]) {
              trans = e[3]
            }
          })
        }
      }
      this.$log.debug(trans)
      await this.loadLocale({
        lang: trans
      })
      this.$log.info('loadLocale finish')
    },
    checkLogin: async function () {
      this.closeModal('browser-warning-modal')
      this.$modal.hide('browser-warning-modal')
      let sid = (Vue.cookie.get('QSW_SID')) ? Vue.cookie.get('QSW_SID').split('::') : Vue.cookie.get('QSW_SID')
      this.$log.info('checklogin')
      this.$log.debug(process.env.MODEL)
      if (Vue.cookie.get('QSW_SID')) {
        try {
          await this.auth(sid).then((result) => {
            this.getSystemInfo()
              .then((res) => {
                let tempSid = (sid.length > 1) ? sid[1] : sid
                if (res.data && res.data.error_code === 200 && res.data.result) {
                  let tempMAC = Encrypt.ezEncode(encodeURIComponent(res.data.result.mac.split(':').join('')))
                  this.$log.debug('sid: ', tempSid, 'encodemac: ', tempMAC)
                  if (tempSid === tempMAC) {
                    this.openModal('pwd-update-modal')
                    this.$modal.show('pwd-update-modal')
                  } else {
                    this.$store.commit('login')
                    this.$router.push({
                      name: 'dashboard'
                    })
                    this.$store.commit('updateMenu', {menu: 'dashboard'})
                  }
                }
              }).catch((err) => {
                this.$log.error(err)
              })
          })
        } catch (err) {
          this.$store.commit('logout')
          this.$router.push({
            name: 'login'
          })
        }
      } else {
        this.$store.commit('logout')
        this.$router.push({
          name: 'login'
        })
      }
    },
    goReboot: function () {
      this.$store.commit('setLoadingType', 'restart')
      this.$store.commit('updateFullLoadingStatus', true)
      this.startTime = new Date()
      this.checkRebootingStatus()
      this.setSwitchAction('reboot').then(res => {
        this.$log.info('setSwitchAction')
        this.$log.debug('setSwitchAction', res)
      })
      this.closeModal('switch-reboot-modal')
      this.$modal.hide('switch-reboot-modal')
    },
    checkTimeout: function () {
      clearInterval(this.timeoutInterval)
      if (!this.timeoutInterval) {
        this.timeoutInterval = setInterval(() => {
          if (this.timeoutInterval) {
            let nowTime = new Date()
            if (nowTime - this.qswTimeout >= 3600000) {
              this.$store.commit('updateTimeoutWinStatus', {status: true, type: 'timeout'})
              this.openModal('timeout-warning-modal')
              this.$modal.show('timeout-warning-modal')
              this.timeoutInterval = null
              clearInterval(this.timeoutInterval)
              window.clearInterval(this.timeoutInterval)
              this.$store.commit('updateTimeout')
              this.$forceUpdate()
            }
          } else {
            this.timeoutInterval = null
            window.clearInterval(this.timeoutInterval)
            clearInterval(this.timeoutInterval)
          }
        }, 1000)
      }
    },
    goLogout: async function () {
      this.$store.commit('updateTimeoutWinStatus', {status: false, type: ''})
      this.$store.commit('setLoadingType', 'logout')
      this.$store.commit('updateFullLoadingStatus', true)
      await this.postLogout()
    },
    goUpdate () {
      this.progressText = this.$t('updating')
      this.$store.commit('updateFileStatus', true)
      this.$log.info('upload success')
      if (this.updateType !== 'live') this.postUpgrade()
      setTimeout(() => {
        this.updateInterval = setInterval(() => {
          this.getFWstatus()
        }, this.intervalTime)
        this.getFWstatus()
      }, 5000)
      this.closeModal('digital-signature-modal')
      this.$modal.hide('digital-signature-modal')
    },
    goCancel () {
      this.$store.commit('setUpdateStatus', false)
      this.$store.commit('setProgress', 0)
      this.appProgress = 0
      this.$refs.update.updateProgress(this.appProgress)
    },
    ...mapActions(['getProductByNoAuth', 'auth', 'loadLocale', 'postLogin', 'setSwitchAction', 'getSystemInfo', 'setSystemInfo', 'getFWstatus', 'checkSwitchReboot', 'getPortStatus', 'getFWupdateStatus', 'getUsersLogin', 'postLogout', 'getWebConfig', 'postUpgrade']),
    ...mapMutations([
      'setProgress',
      'openModal',
      'closeModal',
      'updateAutoDetect'
    ])
  },
  computed: {
    ...mapState({
      isLogin: state => state.module.isLogin,
      progress: state => state.module.progress,
      fwUpdating: state => state.module.fwUpdating,
      showFullLoading: state => state.module.showFullLoading,
      sysinfo: state => state.module.sysinfo,
      loadingType: state => state.app.loadingType,
      updateType: state => state.module.updateType,
      currentUser: state => state.module.currentUser,
      showErrorWin: state => state.module.showErrorWin,
      qswTimeout: state => state.module.qswTimeout,
      isShowTimoutWin: state => state.module.isShowTimoutWin,
      systemHostInfo: state => state.module.systemHostInfo,
      accountDuplicate: state => state.module.accountDuplicate,
      intervalTime: state => state.app.intervalTime,
      isAutoDetect: state => state.app.isAutoDetect
    }),
    loadingText () {
      let result = ''
      if (this.loadingType !== '') {
        let str = 'header.' + this.loadingType + 'Load'
        result = this.$t(str)
      }
      return result
    },
    isEnterprice () {
      return this.systemHostInfo.Model && !this.systemHostInfo.Model.includes('M408') && !this.systemHostInfo.Model.includes('M2108')
    }
  }
}
</script>

<style>
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import './assets/scss/iconfont.scss';
@import './assets/scss/fonts.scss';
@import './assets/scss/enterprise.scss';
#app {
  font-family:"icomoon","commonfont","Open Sans", Helvetica, Verdana, Tahoma, "PingFang TC", "Lantinghei TC", "微軟正黑體", "Microsoft JhengHei", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  overflow: hidden;
}

#app {
  height: 100%;
  min-width: 1250px;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-image: linear-gradient(45deg, #071533 0%, #1988BF 100%);
}

html {
  height: 100%;
}

h2 {
  margin-top: 0px;
}

body {
  height: 100%;
  margin: 0;
}

.progress-circle {
  user-select: none;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.progress-text {
  text-align: center;
  position: relative;
  top: calc(50% + 100px);
  font-size: 19px;
}
.progress-circle>.progress-logo {
  text-align: center;
  position: absolute;
  background-color: initial;
  height: 100%;
  width: 100%;
}
.progress-circle>.progress-logo>.circle.login-progress-circle {
  top: calc(50% - 95px);
  left: calc(50% - 95px);
  display: table;
}

.progress-circle>.progress-logo>.circle.login-progress-circle .percent-text {
  font-size: 60px;
}
.restart-loading {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.restart-content {
    width: 100%;
    position: absolute;
    z-index: 1001;
    top: calc(50% + 70px);
}
.restart-text {
    width: fit-content;
    margin: auto;
    font-size: 18px;
    line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue